"use strict";
/**
 * Created by SH: 02/20/2020
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReelEngineView = void 0;
const Logger_1 = require("@nolimitcity/slot-launcher/bin/utils/Logger");
const SymbolData_1 = require("./symbol/config/SymbolData");
const ReelSpriteSymbol_1 = require("./symbol/ReelSpriteSymbol");
const ReelEngineEvent_1 = require("./event/ReelEngineEvent");
const ReelSpriteSymbolArea_1 = require("./symbol/ReelSpriteSymbolArea");
const StageManager_1 = require("../../stage/StageManager");
const ArrayHelper_1 = require("../../utils/ArrayHelper");
const GameEvent_1 = require("../../event/GameEvent");
const EventHandler_1 = require("../../event/EventHandler");
const MathHelper_1 = require("../../utils/MathHelper");
const GameConfig_1 = require("../../gameconfig/GameConfig");
class ReelEngineView extends PIXI.Container {
    get windowAmount() {
        return this._symbolAmount;
    }
    get isQuickStop() {
        return this._isQuickStop;
    }
    set isQuickStop(value) {
        this._isQuickStop = value;
    }
    get showAmount() {
        return this._showAmount;
    }
    get reelID() {
        return this.config.reelID;
    }
    get AllStickySymbols() {
        return this._stickyContainer.children;
    }
    get AllSymbols() {
        return this._areaContainer.children;
    }
    get AllWindowSymbols() {
        return this.AllSymbols.filter(sym => { return (sym.posID >= 0 && sym.posID < this.windowAmount); });
    }
    get topSymbol() {
        return this.AllSymbols[0];
    }
    get bottomSymbol() {
        return this.AllSymbols[this.AllSymbols.length - 1];
    }
    set AllSymbols(symbols) {
        this._areaContainer.removeChildren();
        symbols.sort((a, b) => { return a.posID - b.posID; });
        symbols.forEach(sym => { this._areaContainer.addChild(sym); });
    }
    get engineConfig() {
        return this.config.engine_config;
    }
    get reelDim() {
        return this.engineConfig.DIM;
    }
    get maxHeight() {
        return this.reelDim.HEIGHT;
    }
    get maxWidth() {
        return this.reelDim.WIDTH;
    }
    findHitPosRow(symbolID) {
        const sym = this.getSymbol(symbolID);
        if (!sym)
            Logger_1.Logger.warn("Couldn't find the hitPos:" + symbolID + ", on Reel:" + this.reelID + ". Returning -1.");
        return sym ? sym.posID : -1;
    }
    symbolExcist(symbolID) { return !!this.getSymbol(symbolID); }
    getSymbol(symbolID) {
        const sticky = this.AllStickySymbols.find((sticky) => { return sticky.isHitPos(symbolID); });
        const sym = this.AllSymbols.find((sym) => { return sym.isHitPos(symbolID); });
        if (!sticky && !sym)
            Logger_1.Logger.warn("Couldn't find symbolID:" + symbolID + ", on Reel:" + this.reelID + ". Returning -1.");
        return sticky || sym;
    }
    constructor(config) {
        super();
        this._hasInit = false;
        this._isQuickStop = false;
        this._nextReelSetName = "BASE_REELSET";
        /* ----------------  */
        this._areaContainer = new PIXI.Container();
        // Don't know if this is needed. It's possible to create an seperated class that handles this.
        this._stickyContainer = new PIXI.Container();
        // Used for calculating the static transformPositions on noneMoving reel. Feel free to refractor&optimize away this.
        this._posContainer = new PIXI.Container();
        this.config = config;
        this.addChildObjOrder();
        StageManager_1.StageManager.getLayer(this.engineConfig.LAYER).addChild(this);
    }
    addChildObjOrder() {
        this.mask = this.createGraphic();
        this.addChild(this._areaContainer);
        this.addChild(this._stickyContainer);
        this.addChild(this._posContainer);
    }
    onStageResized(resizeData) {
        if (this._hasInit) {
            this.onResize(resizeData);
            EventHandler_1.EventHandler.dispatchEvent(new GameEvent_1.GameEvent(ReelEngineEvent_1.ReelEngineEvent.REEL_RESIZED, this.reelID));
        }
    }
    createGraphic() {
        const graphicBg = new PIXI.Graphics();
        graphicBg.beginFill(0x000000, 1);
        graphicBg.drawRect(-SymbolData_1.SymbolData.DEFAULT_SYMBOL.DIM.WIDTH * 0.5, -SymbolData_1.SymbolData.DEFAULT_SYMBOL.DIM.HEIGHT * 0.5, SymbolData_1.SymbolData.DEFAULT_SYMBOL.DIM.WIDTH, this.reelDim.HEIGHT);
        graphicBg.endFill();
        this.addChild(graphicBg);
        return graphicBg;
    }
    createNewSymbol(id, symbolName, state, type) { return new ReelSpriteSymbol_1.ReelSpriteSymbol(id, symbolName, state, type); }
    createRandomSymbol() {
        return this.createNewSymbol(this.children.length, this.generateNextSymbol(this._currentReelSet));
    }
    setStickies(positions) {
        for (let i = 0; i < positions.length; i++) {
            const sym = this.getSymbol(positions[i]);
            if (!sym) {
                Logger_1.Logger.warn("Couldn't find sym with posID: " + positions[i]);
                continue;
            }
            if (this.containsSticky(sym.posID) >= 0) {
                this._stickyContainer.children[this.containsSticky(sym.posID)] = sym;
            }
            this._stickyContainer.addChild(sym);
        }
        this._stickyContainer.children.forEach(symbols => symbols.changeState({ state: ReelSpriteSymbolArea_1.ReelSymbolStates.STICKY }));
    }
    clearStickies() {
        let c = this._stickyContainer.removeChildren();
        c.forEach(d => { d.destroy(); });
        c = [];
        this._stickyContainer = new PIXI.Container();
    }
    mergeStickies(positions) {
        if (positions && positions.length > 0) {
            for (let i = 0; i < positions.length; i++) {
                const indx = this.AllStickySymbols.findIndex((sym) => { return sym.posID == positions[i]; });
                for (let k = 0; k < this.AllSymbols.length; k++) {
                    if (this.AllSymbols[k].posID == this.AllStickySymbols[indx].posID) {
                        this.AllSymbols[k].destroy();
                        this._areaContainer.addChildAt(this._stickyContainer.removeChildAt(indx), k);
                    }
                }
            }
        }
        else {
            for (let c = 0; c < this.AllSymbols.length; c++) {
                const indx = this.AllStickySymbols.findIndex((sym) => { return sym.posID == this.AllSymbols[c].posID; });
                if (indx == -1)
                    continue;
                this.AllSymbols[c].destroy();
                this._areaContainer.addChildAt(this._stickyContainer.removeChildAt(indx), c);
            }
        }
    }
    containsSticky(posID) {
        for (let k = 0; k < this._stickyContainer.children.length; k++) {
            const stickySym = this._stickyContainer.children[k];
            if (stickySym.posID == posID)
                return k;
        }
        return -1;
    }
    replaceReelItem(removePos, posID, size) {
        let addHitPos = [];
        for (let p = 0; p < removePos.length; p++) {
            addHitPos = addHitPos.concat(this.getSymbol(removePos[p]).hitPos);
        }
        this.removeReelItem(removePos);
        let reelSymbol = this.createNewSymbol(posID, "W", ReelSpriteSymbolArea_1.ReelSymbolStates.NORMAL, size);
        let symbolAbove = this.getSymbol(posID - 1);
        reelSymbol.hitPos = addHitPos;
        let symbolposY = symbolAbove.position.y + symbolAbove.symbolHeight * 0.5;
        reelSymbol.y = symbolposY + reelSymbol.symbolHeight * 0.5;
        this._areaContainer.addChild(reelSymbol);
        this.AllSymbols.sort((a, b) => { return a.posID - b.posID; });
    }
    addSymbol(symbol) {
        this._areaContainer.addChild(symbol);
        this.AllSymbols.sort((a, b) => { return a.posID - b.posID; });
    }
    removeReelItem(removePos) {
        let find = true;
        while (find) {
            find = false;
            for (let i = 0; i < this.AllSymbols.length; i++) {
                if (removePos.indexOf(this.AllSymbols[i].posID) >= 0) {
                    this._areaContainer.removeChildAt(i);
                    find = true;
                    break;
                }
            }
        }
    }
    generateNextSymbol(reelSet) {
        if (!this._nextSymbol)
            this._nextSymbol = ArrayHelper_1.ArrayHelper.getRandomElementFromArray(reelSet);
        return this._nextSymbol;
    }
    onResize(dimData) {
        if (GameConfig_1.GameConfig.instance.REEL_ENGINE_POSITIONS)
            this.position = MathHelper_1.MathHelper.pointAdd(GameConfig_1.GameConfig.instance.REEL_ENGINE_POSITIONS[this.reelID], dimData.position);
        this.scale = dimData.scale;
    }
}
exports.ReelEngineView = ReelEngineView;
//# sourceMappingURL=ReelEngineView.js.map